import React, { useEffect, useState, useRef } from "react";
import styles from "./style.module.scss";
import { Button, Col, Input, List, Row, Skeleton, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { MessageCart } from "./components/massgeCart/MassageCart";
import io from "socket.io-client";
import axios from "axios";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import {
  CloseOutlined,
  PaperClipOutlined,
  SendOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { FiFileText } from "react-icons/fi";
import LoadingPage from "../../components/general/layout/loading-page";
import { AiOutlineUser } from "react-icons/ai";
import { isToday, isYesterday } from "../../utils/helpers/format-time";
import dayjs from "dayjs";

const { TextArea } = Input;

const Chat = () => {
  const [selectedConversation, setSelectedConversation] = useState<number | null>(null);
  const [message, setMessage] = useState<string>("");
  const [file, setFile] = useState<File | null>(null);
  const [chats, setChats] = useState<any[]>([]);
  const [messages, setMessages] = useState<any[]>([]);
  const { t } = useTranslation();
  const socketRef = useRef<any>(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [loadingChats, setLoadingChats] = useState<boolean>(true);
  const [loadingMessages, setLoadingMessages] = useState<boolean>(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [page, setPage] = useState(1);
  const [hasMoreMessages, setHasMoreMessages] = useState(true);
  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const initialLoadRef = useRef(true);
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  useEffect(() => {
    if (initialLoadRef.current && !loadingMessages) {
      messagesEndRef.current?.scrollIntoView();
      initialLoadRef.current = false;
    }
  }, [selectedConversation, loadingMessages]);

  useEffect(() => {
    if (!loadingMessages && !initialLoadRef.current) {
      const container = messagesContainerRef.current;
      const isAtBottom =
        container &&
        container.scrollHeight - container.scrollTop - container.clientHeight < 100;

      if (isAtBottom) {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [messages]);

  useEffect(() => {
    fetchChats();
  }, []);

  useEffect(() => {
    setupSocketConnection();
  }, [selectedConversation]);

  useEffect(() => {
    const container = messagesContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      if (container.scrollTop === 0 && hasMoreMessages && !loadingMessages) {
        fetchMessages(selectedConversation, page + 1, true);
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [selectedConversation, page, hasMoreMessages, loadingMessages]);


  const groupMessagesByDate = (messages) => {
    const sortedMessages = [...messages].sort(
      (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );

    const grouped = [];
    let currentDateLabel = "";

    for (const message of sortedMessages) {
      const dateStr = message.created_at;
      let label = "";

      if (isToday(dateStr)) {
        label = t("today");
      } else if (isYesterday(dateStr)) {
        label = t("yesterday");
      } else {
        const date = dayjs.utc(dateStr);
        label = date.format("DD MMMM YYYY");
      }

      if (label !== currentDateLabel) {
        grouped.push({ separator: label });
        currentDateLabel = label;
      }

      grouped.push(message);
    }

    return grouped;
  };

  const setupSocketConnection = () => {
    // console.log("Setting up socket connection...");
    socketRef.current = io("https://chat.sahmL5air.rocheta2.com/");

    socketRef.current.on("connect", () => {
      console.log("Socket connected:", socketRef.current.id);
    });

    socketRef.current.on("disconnect", () => {
      console.log("Socket disconnected");
    });


    socketRef.current.off("receive_message");

    chats.map((chat,index)=>{
    socketRef.current.emit("register", {
      chat_id: chat.id,
      is_charity: true,
    });})
  

    socketRef.current.on("receive_message", (data) => {
      console.log("Received message via socket:", data);

      setChats((prevChats) => {
        return prevChats.map((chat) => {
          if (chat.id === data.chat_id && !selectedConversation == data.chat_id) {
            const updatedChat = {
              ...chat,
              unSeenMessages: chat.unSeenMessages + 1,
            };
            return updatedChat;
          }
          return chat;
        }).sort((a, b) => {
          if (b.unSeenMessages !== a.unSeenMessages) {
            return b.unSeenMessages - a.unSeenMessages;
          }
          return 0;
        });
      });
      

      if (selectedConversation == data.chat_id) {
        const receivedMessage = {
          body: data.body || "",
          file: data.file || null,
          isPdf: data.isPdf || false,
          created_at: data.created_at || new Date().toISOString(),
          sender_name: data.sender_type === "user" ? "User" : "Admin",
          typeForAdmin: data.sender_type === "user" ? "user" : "admin",
        };
        setMessages((prev) => [...prev, receivedMessage]);
      }
    });
  };


  const fetchChats = async () => {
    setLoadingChats(true);
    try {
      const token = localStorage.getItem("access_token");
      // console.log("Fetching chats from server...");
      const response = await axios.get(
        "https://dev.sahml5air.rocheta2.com/api/chats",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("Fetched chats:", response.data);
      const formattedChats = response.data.map((chat) => ({
        id: chat.id,
        name: `${chat.user.firstName || ""} ${chat.user.lastName || ""}`.trim(),
        phoneNumber: chat.user.cleanMobile,
        unSeenMessages: chat.unSeenMessages,
      }));
      setChats(formattedChats);
    } catch (error) {
      console.error("Error fetching chats:", error);
      setChats([]);
    } finally {
      setLoadingChats(false);
    }
  };

  const fetchMessages = async (chatId: number, pageNumber = 1, append = false) => {
    if (loadingMessages || !hasMoreMessages) return;
    setLoadingMessages(true);
    

    const container = messagesContainerRef.current;
    const scrollHeightBefore = container?.scrollHeight;

    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(
        `https://dev.sahml5air.rocheta2.com/api/indexForAdmin?chatId=${chatId}&page=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const fetchedMessages = response.data.data.reverse();
      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.id === chatId ? { ...chat, unSeenMessages: 0 } : chat
        )
      );

      if (fetchedMessages.length === 0) {
        setHasMoreMessages(false);
      }

      if (append) {
        setMessages((prev) => [...fetchedMessages, ...prev]);

        setTimeout(() => {
          if (container && scrollHeightBefore !== undefined) {
            const scrollHeightAfter = container.scrollHeight;
            const scrollTopDifference = scrollHeightAfter - scrollHeightBefore;

            const buffer = 100;
            container.scrollTop = scrollTopDifference - buffer;
          }
        }, 0);
      } else {
        setMessages(fetchedMessages);
      }

      setPage(pageNumber);
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setLoadingMessages(false);
    }
  };


  const handleChatSelect = (chatId: number) => {
    if (chatId == selectedConversation) return;
    // console.log(`Selecting chat with ID: ${chatId}`);

    initialLoadRef.current = true;
    setSelectedConversation(chatId);
    setMessages([]);
    setPage(1);
    setHasMoreMessages(true);
    fetchMessages(chatId, 1);
  };

  const sendMessage = async () => {
    if (!message.trim() && !file) return;

    const tempMessageId = Date.now();

    const tempMessage = {
      id: tempMessageId,
      body: message,
      file: filePreview,
      created_at: new Date().toISOString(),
      sender_name: "You",
      typeForAdmin: "admin",
      status: "sending",
    };

    setMessages((prev) => [...prev, tempMessage]);
    setMessage("");
    setFile(null);
    setFilePreview(null);

    const token = localStorage.getItem("access_token");
    const formData = new FormData();
    formData.append("body", message);
    formData.append("isCharity", "1");
    formData.append("chatId", String(selectedConversation));
    if (file) {
      formData.append("file", file);
    }

    try {
      const response = await axios.post(
        "https://dev.sahml5air.rocheta2.com/api/messages",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === tempMessageId
            ? {
              ...response.data,
              sender_name: "You",
              typeForAdmin: "admin",
              status: "sent",
            }
            : msg
        )
      );

      if (socketRef.current) {
        socketRef.current.emit("send_message", {
          is_charity: true,
          chat_id: selectedConversation,
          message: {
            id: response.data.id,
            created_at: response.data.created_at,
            file: response.data.file || null,
            isPdf: response.data.file?.includes(".pdf"),
            body: response.data.body,
          },
        });
      }
    } catch (error) {
      console.error("Error sending message:", error);

      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === tempMessageId
            ? {
              ...msg,
              status: "failed",
            }
            : msg
        )
      );
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/svg+xml",
        "image/heif",
        "image/webp",
      ];
      if (allowedTypes.includes(selectedFile.type)) {
        setFile(selectedFile);
        setFilePreview(URL.createObjectURL(selectedFile));
      } else {
        alert("Only image files are allowed.");
        e.target.value = "";
        return;
      }
    }
  };

  const handleEmojiSelect = (emoji: any) => {
    setMessage((prevMessage) => prevMessage + emoji.native);
    setShowEmojiPicker(false);
  };

  const handleRemoveFile = () => {
    setFile(null);
    setFilePreview(null);
  };

  return (
    <Row className={styles["chat-container"]}>
      <Col span={6} className={`${styles["sidebar"]}`}>
        <div className={styles["chat-header"]}>{t("last_chats")}</div>
        {loadingChats ? (
          <div className={styles.skeletonContainer}>
            {[...Array(5)].map((_, i) => (
              <div style={{ padding: "5px" }} key={i}>
                <Skeleton.Button active size="large" block />
              </div>
            ))}
          </div>
        ) : (
          <List
            dataSource={chats}
            renderItem={(item) => (
              <List.Item
                onClick={() => handleChatSelect(item.id)}
                style={{
                  padding: "10px",
                  width: "100%",
                  backgroundColor:
                    selectedConversation === item.id ? "#57a5a5" : "transparent",
                  transition: "background-color 0.3s",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* Avatar */}
                <div className={styles["chat-avatar"]}>
                  {item.image ? (
                    <img
                      src={item.image}
                      alt="avatar"
                    />
                  ) : (
                    <AiOutlineUser size={24} color="#888" />
                  )}
                </div>

                {/* Content */}
                <div className={styles["chat-content"]}>
                  <span className={styles["chat-name"]}>
                    {item.name ? item.name : item.phoneNumber}
                  </span>
                  {item.name && (
                    <span className={selectedConversation === item.id ? `${styles["chat-phone"]} ${styles["active-text"]}` : styles["chat-phone"]}>
                      {item.phoneNumber}
                  </span>
                  )}
                </div>
                {item.unSeenMessages > 0 && (
                  <div className={styles.badge}>{item.unSeenMessages}</div>
                )}
              </List.Item>
            )}
          />
        )}
      </Col>
      <Col
        span={18}
        style={{ position: "absolute", right: 0, top: 0, width: "80%", height: "100%" }}
      >
        <div
          ref={messagesContainerRef}
          className={`${styles["message-container"]} ${filePreview ? styles.file : styles.emptyFile}`}
        >

          {!selectedConversation ? (
            <div className={styles["empty-state"]}>
              {t("select_chat_to_start_messaging")}
            </div>
          ) : loadingMessages && initialLoadRef.current ? (
            <div style={{ overflowY: "hidden" }}>{
              [...Array(4)].map((_, i) => <div key={i} dir={i % 2 === 0 ? "rtl" : "ltr"}><Skeleton style={{ marginTop: "4px", maxWidth: "60%" }} active /></div>)
            }</div>
          ) : messages.length === 0 ? (
            <div className={styles["empty-state"]}>
              {t("no_messages_yet")}
            </div>
          ) : (
            <>
              {loadingMessages && !initialLoadRef.current && (
                <LoadingPage />
              )}
              {groupMessagesByDate(messages).map((item, index) => {
                if (item.separator) {
                  return (
                    <div key={`sep-${index}`} className={styles["date-separator"]}>
                      {item.separator}
                    </div>
                  );
                }

                return <MessageCart key={item.id || index} message={item} />;
              })}
            </>
          )}


          <div ref={messagesEndRef} />
        </div>
        {selectedConversation && (
          <div
            className={`${styles["input-area"]} ${filePreview == null ? styles.emptyFile : styles.file}`}
            style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}
          >
            {filePreview && (
              <div className={styles["file-preview"]}>
                {file?.type.startsWith("image/") ? (
                  <img src={filePreview} alt="Preview" />
                ) : (
                  <div style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                    <FiFileText /> {file?.name}
                  </div>
                )}
                <Button
                  type="text"
                  icon={<CloseOutlined />}
                  onClick={handleRemoveFile}
                  style={{ marginLeft: "5px", fontSize: "12px" }}
                />
              </div>
            )}
            <Flex gap="8px">
              <TextArea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage();
                  }
                }}
                placeholder={t("type_a_message")}
                autoSize={{ minRows: 1, maxRows: 4 }}
                style={{
                  borderRadius: "25px",
                  padding: "10px 15px",
                  fontSize: "16px",
                }}
              />
              <Flex justify="space-between" align="center" gap="5px">
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  accept="image/jpeg,image/png,image/gif,image/svg+xml,image/heif,image/webp"
                />
                <Button
                  shape="circle"
                  icon={<PaperClipOutlined />}
                  onClick={() =>
                    document.getElementById("fileInput")?.click()
                  }
                />
                <Button
                  shape="circle"
                  icon={<SmileOutlined />}
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                />
                {showEmojiPicker && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "70px",
                      right: "20px",
                      zIndex: 1000,
                    }}
                  >
                    <Picker data={data} onEmojiSelect={handleEmojiSelect} />
                  </div>
                )}
                <Button
                  type="primary"
                  shape="circle"
                  icon={
                    <span style={{ transform: isRTL ? 'scaleX(-1)' : 'none', display: 'inline-block' }}>
                      <SendOutlined />
                    </span>
                  }
                  onClick={sendMessage}
                  disabled={!message.trim() && !file}
                />
              </Flex>
            </Flex>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default Chat;